import axios from 'axios'
import store from '@/store'
import storage from 'store'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'

// const isProd = process.env.NODE_ENV === 'production'
// 创建 axios 实例

// const domain = !isProd ? '/api' : 'http://admin.osctraining.com/api'
const request = axios.create({
  // API 请求的默认前缀
  baseURL: '/api',
  timeout: 0 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data
    // 从 localstorage 获取 token
    const token = storage.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      notification.error({
        message: '认证失败',
        description: '授权验证失败，请重新登录'
      })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
    if (error.response.status === 422) {
      notification.error({
        message: 'Error',
        description: data[Object.keys(data)[0]][0]
      })
    }
    if (error.response.status === 404) {
        notification.error({
          message: 'Error',
          description: data.message
        })
      }

    if (error.response.status === 405) {
      notification.error({
        message: 'Error',
        description: data.message
      })
    }
  } else {
    notification.error({
      message: '提示',
      description: '请求超时，请联系网络管理员'
    })
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  const token = storage.get(ACCESS_TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers['Authorization'] = token
  }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use(response => {
  const data = response.data
  const token = response.headers.authorization
  if (token) {
    store.dispatch('RefreshToken', token)
  }
  if (data.code === '401') {
    notification.error({
      message: '认证失败',
      description: data.msg
    })
  }
  if (data.code === '422') {
    notification.error({
      message: '提示',
      description: data.msg
    })
  }
  if (data.code === '201') {
    notification.error({
      message: data.msg,
      description: data.result
    })
  }
  if (data.code === '200') {
    return data
  }
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}
